import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

export type RoomAccessStatus =
  | 'join_now'
  | 'waiting_room'
  | 'not_ready'
  | 'invalid'
  | 'requires_passcode';

export interface RoomAccessResult {
  status: RoomAccessStatus;
  conferenceId: string | null;
}

const MOCK_STATUS_MAP: Record<string, RoomAccessStatus> = {
  'inv_join':    'join_now',
  'inv_wait':    'waiting_room',
  'inv_noready': 'not_ready',
  'inv_pass':    'requires_passcode',
  'inv_invalid': 'invalid',
};

@Injectable({ providedIn: 'root' })
export class RoomAccessService {
  validateInvitation(code: string): Observable<RoomAccessResult> {
    const status: RoomAccessStatus = MOCK_STATUS_MAP[code] ?? 'invalid';
    const mock: RoomAccessResult = {
      status,
      conferenceId: status !== 'invalid' ? 'conf_123' : null,
    };

    return of(mock).pipe(delay(300));
  }
}
